import React from 'react';
import Commonfooter from '../../UI/FooterCommon/Commonfooter'

import './Footer.css';

/**
* @desc Header section for client
* @version 1.0.1
* @author Amrutha
*/

const Footer= () =>{
    return (     
      <div className="cli-footer-main">
        <div className="cli-footer-text">
          <Commonfooter />
        </div>
      </div>
    );
  }


export default Footer;



// WEBPACK FOOTER //
// ./src/components/Client/Footer/Footer.js